<template>
    <div class="tile-content">
        <div class="tile-subtitle">
            <h3 v-fs-block>{{relatedTransaction.label | capitalize }} {{'transaction' | pluralize(relatedTransaction.transactions.length) }}</h3>
        </div>
        <ul class="list list-group">
            <li v-for="(transactionId, index) in relatedTransaction.transactions" class="list-item">
                <v-icon icon="transactions" class="no-flex inline-s"/>
                <router-link
                    :disabled="isProcessing"
                    :key="index"
                    :to="{name: 'transaction-details', params: {id: transactionId}}"
                    class="text-left btn btn-link no-flex">
                    {{transactionId}}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';

    export default {
        name: 'transaction-summary-related',
        components: {
            vIcon,
        },
        props: {
            relatedTransaction: {
                type: Object,
            },
            isProcessing: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
